import { NotificationDefinition } from '../../types'
import { InvoiceAutoIssueAccountingLockedHeader } from './InvoiceAutoIssueAccountingLockedHeader'
import { InvoiceAutoIssueAccountingLockedListItem } from './InvoiceAutoIssueAccountingLockedListItem'
import { InvoiceAutoIssueAccountingLockedPreview } from './InvoiceAutoIssueAccountingLockedPreview'

export const invoiceAutoIssueAccountingLockedDefinition: NotificationDefinition =
  {
    listItemContent: InvoiceAutoIssueAccountingLockedListItem,
    previewHeaderContent: InvoiceAutoIssueAccountingLockedHeader,
    previewContent: InvoiceAutoIssueAccountingLockedPreview
  }
